// extracted by mini-css-extract-plugin
export default {"container_categories":"style_container_categories__CmjJS","category":"style_category__wVJvj","cont_card":"style_cont_card__Uymjf"};